import { Link } from "react-router-dom";
import { hotKeywords } from "@/mocks/chigua";
import { topHot } from "@/lib/chiguaData";
import { kindBadge } from "@/lib/chiguaData";

export function HeroHome() {
  return (
    <section className="relative overflow-hidden border-b border-background-200">
      {/* 底层装饰色块 */}
      <div className="pointer-events-none absolute -left-32 top-10 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl" aria-hidden="true" />
      <div className="pointer-events-none absolute right-0 top-0 h-96 w-96 rounded-full bg-accent-100/50 blur-3xl" aria-hidden="true" />
      <div
        className="pointer-events-none absolute right-1/2 top-8 hidden h-full w-px bg-gradient-to-b from-transparent via-background-200 to-transparent lg:block"
        aria-hidden="true"
      />

      <div className="relative mx-auto grid max-w-[1400px] items-center gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-12">
        {/* 左侧主标题 */}
        <div className="lg:col-span-7 lg:pr-10">
          <p className="flex flex-wrap items-center gap-2 text-xs font-medium text-foreground-500">
            <span className="rounded bg-accent-100 px-2 py-1 font-semibold text-accent-700">今日吃瓜 · 内幕深扒</span>
            <span className="flex items-center gap-1">
              <i className="ri-calendar-2-line text-secondary-600" aria-hidden="true" />
              2026年9月6日 星期日
            </span>
          </p>

          <h1 className="mt-5 font-heading text-[34px] font-bold leading-[1.2] text-foreground-950 md:text-5xl lg:text-[56px]">
            把散落的线索，
            <br />
            收拢成一条
            <span className="relative inline-block text-primary-600">
              完整时间线
              <span className="absolute -bottom-1 left-0 h-1.5 w-full rounded bg-primary-200" aria-hidden="true" />
            </span>
            。
          </h1>

          <p className="mt-6 max-w-xl text-[15px] leading-7 text-foreground-600 md:text-base">
            这里只按<strong className="font-semibold text-foreground-900">公开材料</strong>整理
            <strong className="font-semibold text-foreground-900">内幕消息</strong>与
            <strong className="font-semibold text-foreground-900">内幕真相</strong>，把零散线索交叉比对成完整叙事，不做主观猜测。看后可形成自己的判断，一网看尽，不用翻。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/list/shenba"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-[15px] font-semibold text-background-50 transition hover:bg-primary-600"
            >
              进入深扒档案
              <i className="ri-folder-open-line" aria-hidden="true" />
            </Link>
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-900/15 bg-background-50 px-6 py-3.5 text-[15px] font-medium text-foreground-800 transition hover:border-primary-400 hover:text-primary-700"
            >
              <i className="ri-fire-line text-accent-500" aria-hidden="true" />
              查看全站热榜
            </a>
          </div>

          {/* 关键词 */}
          <div className="mt-8 flex flex-wrap items-center gap-2">
            <span className="flex items-center gap-1 text-xs font-semibold uppercase tracking-wider text-foreground-400">
              <i className="ri-price-tag-3-line" aria-hidden="true" />
              热词
            </span>
            {hotKeywords.slice(0, 5).map((k) => (
              <span
                key={k}
                className="rounded-full border border-background-200 bg-background-100/70 px-3 py-1 text-xs text-foreground-600 transition hover:border-primary-300 hover:text-primary-700"
              >
                {k}
              </span>
            ))}
          </div>
        </div>

        {/* 右侧热榜 */}
        <aside className="lg:col-span-5" id="hot" aria-label="全站热榜">
          <div className="rounded-xl border border-background-200 bg-background-50/90 p-5 md:p-6">
            <div className="flex items-center justify-between">
              <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <span className="grid h-7 w-7 place-items-center rounded-md bg-accent-500 text-background-50">
                  <i className="ri-fire-fill text-sm" aria-hidden="true" />
                </span>
                全站热榜
              </h2>
              <span className="text-xs text-foreground-400">按阅读热度实时排序</span>
            </div>
            <ol className="mt-4 divide-y divide-background-100">
              {topHot.map((a, i) => (
                <li key={a.slug}>
                  <Link to={`/story/${a.slug}`} className="group flex items-start gap-3 py-3">
                    <span
                      className={`mt-0.5 font-display-sc text-2xl leading-none ${
                        i < 3 ? "text-primary-500" : "text-foreground-300"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate font-medium text-foreground-900 transition group-hover:text-primary-700">
                        {a.title}
                      </span>
                      <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                        <span className={`rounded px-1.5 py-0.5 text-background-50 ${kindBadge(a.kind)}`}>{a.kind}</span>
                        <span>{a.minutes} 分钟</span>
                        <span className="inline-flex items-center gap-1">
                          <i className="ri-fire-line text-accent-500" aria-hidden="true" />
                          {Math.round(a.heat / 10000)}w
                        </span>
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
            <Link
              to="/list/shenba"
              className="mt-2 inline-flex w-full items-center justify-center gap-1 whitespace-nowrap rounded-md bg-background-100 py-2.5 text-sm font-medium text-foreground-700 transition hover:bg-accent-100 hover:text-accent-800"
            >
              查看更多深扒复盘
              <i className="ri-arrow-right-down-line" aria-hidden="true" />
            </Link>
          </div>
        </aside>
      </div>

      {/* 跑马灯关键词条 */}
      <div className="relative border-t border-background-200 bg-foreground-950 text-background-100">
        <div className="flex overflow-hidden">
          <div className="ticker-track flex shrink-0 items-center whitespace-nowrap py-2.5">
            {[0, 1].map((dup) => (
              <span key={dup} className="flex shrink-0 items-center text-xs tracking-wide">
                {hotKeywords.map((k, i) => (
                  <span key={`${dup}-${i}`} className="flex items-center">
                    <span className="px-4">{k}</span>
                    <i className="ri-circle-fill text-[5px] text-secondary-400" aria-hidden="true" />
                  </span>
                ))}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}